import { BwjValidityState } from "./bwj-validity-state";

export type InputHandler<T> = (value:T) => void;

export class BwjInput<TValue, TAdditionalInfo = unknown> {
    constructor(
        public value: TValue,
        public validity: BwjValidityState = BwjValidityState.Valid,
        public message?: string) {
    }

    public additionalInfo?: TAdditionalInfo;
    public id?: string;
    public description?: string;
}